// src/lib/opportunity/formatDepositResolver.ts
//
// Client-side loader for manager deposit-rule presets at quote/PDF time.

import { FORMAT_CALC_PRODUCT_TYPE_WILDCARD } from "./formatCalcLineTypes.js";
import { getFormatDepositRule } from "./formatDepositRuleClient.js";
import {
  selectFormatDepositRule,
  type FormatDepositRule,
  type FormatDepositRuleDef,
} from "./formatDepositTypes.js";
import type { OpportunityFormatKey } from "../../types/opportunity.js";

export { selectFormatDepositRule } from "./formatDepositTypes.js";

export async function resolveFormatDepositRule(args: {
  formatKey: OpportunityFormatKey;
  productType: string;
}): Promise<FormatDepositRuleDef> {
  const [specific, wildcard] = await Promise.all([
    getFormatDepositRule({ format_key: args.formatKey, product_type: args.productType }),
    getFormatDepositRule({
      format_key: args.formatKey,
      product_type: FORMAT_CALC_PRODUCT_TYPE_WILDCARD,
    }),
  ]);
  const rules: FormatDepositRule[] = [];
  if (specific.ok && specific.data.rule) rules.push(specific.data.rule);
  if (wildcard.ok && wildcard.data.rule) rules.push(wildcard.data.rule);
  return selectFormatDepositRule({ rules, productType: args.productType });
}
